module.exports = __webpack_public_path__ + "img/banner-header-new_03-auditoria-en-seguros.1f1b84ee.jpg";